import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
// import { RefreshTokenResponse } from '../models/auth.model';


@Injectable({
  providedIn: 'root'
})
export class TokenService {

  baseUrl: string = '';

  constructor(
    private http: HttpClient,
    
  ) { }

  refreshAccessToken() {
    return this.http
      .post<any>(`${this.baseUrl}/auth/jwt/refresh/`, {
        refresh: this.getRefreshToken(),
      });
  }

  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  getRefreshToken() {
    return localStorage.getItem('refresh_token');
  }

  setAccessToken(token: string) {
    localStorage.setItem('access_token', token);
  }

  setRefreshToken(token: string) {
    localStorage.setItem('refresh_token', token);
  }

  removeToken() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
}
